import React from "react";

const FaceDetan = () => {
  return (
    <div className="faceWaxingContainer">
      <h2>De-tan Treatments at SCENT</h2>
      <h3>Restore Your Skin’s Natural Glow</h3>
      <p>
        Bangalore's sunny climate can lead to tanning, making your skin look
        dull and uneven. Our de-tan treatments are designed to effectively
        remove tan and restore your skin’s natural glow.
      </p>
      <h3>Benefits of De-tan Treatments</h3>
      <li>
        <h6>Even Skin Tone:</h6>Our de-tan treatments help to even out your skin
        tone by removing tan and pigmentation.
      </li>
      <li>
        <h6>Hydration and Nourishment:</h6> These treatments also hydrate and
        nourish the skin, leaving it soft and supple.
      </li>
      <li>
        <h6>Brightening Effect:</h6> Regular de-tan treatments can brighten your
        complexion, giving you a radiant look.
      </li>
      <h3>Our De-tan Treatment Process</h3>
      <li>
        <h6>1. Assessment:</h6>We start with an assessment of your skin to
        determine the extent of tanning and any other concerns.
      </li>
      <li>
        <h6>2. Customized Treatment:</h6> Based on the assessment, we customize
        the de-tan treatment to address your specific needs.
      </li>
      <li>
        <h6>3. Application:</h6> The de-tan product is applied to your skin and
        left to work its magic.
      </li>
      <li>
        <h6>4. Aftercare:</h6> We provide aftercare instructions and products to
        maintain the results of the treatment.
      </li>
    </div>
  );
};

export default FaceDetan;
